import React, { useMemo } from "react";
import { useEffect } from 'react'
import {
  Paper, makeStyles, createStyles, Theme, Card, Grid,
  IconButton, Typography, CircularProgress,
} from "@material-ui/core";
import { green, grey, indigo, deepPurple, red } from '@material-ui/core/colors';
import AttachFileOutlinedIcon from '@material-ui/icons/AttachFile';
import EditIcon from '@material-ui/icons/Edit';
import { typeQaRest } from '../../../../api/helpline/qa'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      maxWidth: "100%",
      padding: theme.spacing(1),
      backgroundColor: deepPurple[50],
      maxHeight: '60vh',
      overflow: 'auto',
    },
    loadingpaper: {
      maxWidth: "100%",
      padding: theme.spacing(1),
      backgroundColor: grey[100],
      maxHeight: 400,
      overflow: 'auto',
    },
    cardroot: {
      margin: theme.spacing(1),
    },
    cardright: {
      maxWidth: "80%",
      textAlign: "left",
      wordBreak: 'break-all',
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      paddingBottom: 0,
      borderStyle: "none",
      backgroundColor: indigo[100],
    },
    noteright: {
      maxWidth: "80%",
      textAlign: "left",
      wordBreak: 'break-all',
      padding: theme.spacing(1),
      borderStyle: "none",
      backgroundColor: indigo[100],
    },
    draftright: {
      maxWidth: "80%",
      textAlign: "left",
      wordBreak: 'break-all',
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      paddingBottom: 0,
      borderStyle: "none",
      color: red[600],
      backgroundColor: indigo[100],
    },
    draftnoteright: {
      maxWidth: "80%",
      textAlign: "left",
      wordBreak: 'break-all',
      padding: theme.spacing(1),
      borderStyle: "none",
      color: red[600],
      backgroundColor: indigo[100],
    },
    button: {
      marginTop: theme.spacing(3),
    },
    cardleft: {
      maxWidth: "80%",
      textAlign: "left",
      wordBreak: 'break-all',
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      paddingBottom: 0,
      borderStyle: "none",
      backgroundColor: 'white',
    },
    noteleft: {
      maxWidth: "80%",
      textAlign: "left",
      wordBreak: 'break-all',
      padding: theme.spacing(1),
      borderStyle: "none",
      backgroundColor: 'white',
    },
    textfield: {
      width: "100%"
    },
    bottominfo: {
      marginBottom: 0,
      marginRight: theme.spacing(1),
      opacity: 0.6,
      textTransform:'none'
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: "2px",
      marginLeft: -12,
    },
    downloadProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -24,
      marginLeft: -24,
    },
    attachedbutton: {
      width: "30px",
      height: "30px",
      marginLeft: theme.spacing(1)
    },
    previewChip: {
      marginTop: theme.spacing(1),
      minWidth: "80px",
      maxWidth: "250px",
    },
    attachedArea: {
      marginTop: theme.spacing(1),
      width: "90%",
    },
    iconButton: {
      width: "30px",
      height: "30px",
      opacity: 0.8,
      float: 'right',
    },
  }),
);

interface Prop {
  dateFormat: (datevalue: Date | string) => string,
  fileloading: boolean,
  qaRest: typeQaRest[],
  fileDownload: (filepath: string) => void,
  handleQARestEditOpen: (editindexnum: number) => void,
  editindex: number,
}
const QAEditArea: React.FC<Prop> = (props) => {
  const classes = useStyles();
  const { dateFormat, qaRest, fileloading, fileDownload, handleQARestEditOpen, editindex } = props

  const activeColor = (num: number) => {
    if (num === editindex) {
      return '#b2ff59' //lightgreen[A200]
    } else {
      return ''
    }
  }
  const employeeJustify = (val: string | null | undefined) => {
    if (val === 'Q') {
      return "flex-start"
    } else {
      return "flex-end"
    }
  }

  const newLine = (str: string, variantval: "body1" | "body2" | "caption") => {
    return str.split(/\r\n|\n/).map((value, index) => {
      if (value) {
        return <Typography variant={variantval}>{value}</Typography>
      } else {
        return <br />
      }
    })
  }


  //QAresponse Area End view
  useEffect(() => {
    let ele = document.getElementById('paper')
    if (ele) {
      ele.scrollTop = ele.scrollHeight;
    }
  }, [qaRest]);

  const indexNumber = useMemo((): (number | "d")[] => {
    if (qaRest.length !== 0) {
      const indexNum: (number | "d")[] = qaRest.map((value, index) => (value.qaFlg === 'd' ? value.qaFlg : index))
      let viewnumber = 1
      let viewList: (number | "d")[] = []
      for (let i = 0; i < indexNum.length; i++) {
        if (typeof (indexNum[i]) === 'number') {
          viewList.push(viewnumber)
          viewnumber++
        } else {
          viewList.push('d')
        }
      }
      return viewList
    } else {
      return []
    }
  }, [qaRest])

  return (
    <React.Fragment>
      {qaRest.length !== 0 &&
        <div className={classes.wrapper} >
          <Paper id='paper' variant="outlined" className={fileloading ? classes.loadingpaper : classes.paper} square>
            {qaRest.map((value, index) => {
              return (
                <div className={classes.cardroot}>
                  <Grid container justify={employeeJustify(value.qaFlg)} spacing={1}>
                    <Grid container direction="column" alignItems={employeeJustify(value.qaFlg)}>
                      <Card variant="outlined"
                        className={value.qaFlg === "A" ? (classes.cardright) : value.qaFlg === 'd' ? classes.draftright : (classes.cardleft)} style={{ backgroundColor: activeColor(index) }}>
                        <Typography>{value.answerContents && newLine(value.answerContents, 'body1')}</Typography>
                        <Typography variant="overline" className={classes.bottominfo}>
                          {`No.${indexNumber && indexNumber.length !== 0 && indexNumber[index]}`}
                        </Typography>
                        <Typography variant="overline" className={classes.bottominfo}>
                          回答日:{value.answeSt && dateFormat(value.answeSt)}
                        </Typography>
                        <Typography variant="overline" className={classes.bottominfo}>
                          回答者:{value.aPersonName}
                        </Typography>
                        {value.attachedFile && value.attachedFile.length !== 0 && (
                          <IconButton component="span" size="small" disabled={fileloading} onClick={(event: any) => fileDownload(value.attachedFile!)}>
                            <AttachFileOutlinedIcon />
                          </IconButton>
                        )}
                        {value.attachedFile2 && value.attachedFile2.length !== 0 && (
                          <IconButton component="span" size="small" disabled={fileloading} onClick={(event: any) => fileDownload(value.attachedFile2!)}>
                            <AttachFileOutlinedIcon />
                          </IconButton>
                        )}
                        {value.attachedFile3 && value.attachedFile3.length !== 0 && (
                          <IconButton component="span" size="small" disabled={fileloading} onClick={(event: any) => fileDownload(value.attachedFile3!)}>
                            <AttachFileOutlinedIcon />
                          </IconButton>
                        )}
                        <IconButton color="secondary" className={classes.iconButton} onClick={() => handleQARestEditOpen(index)} key={index} disabled={editindex !== -1}>
                          <EditIcon />
                        </IconButton>
                      </Card>
                      {value.note &&
                        <Card variant="outlined"
                          className={value.qaFlg === "A" ? classes.noteright : value.qaFlg === 'd' ? classes.draftnoteright : classes.noteleft} style={{ backgroundColor: activeColor(index) }} >
                          <Typography>{newLine(value.note, 'body2')}</Typography>
                        </Card>
                      }
                    </Grid>
                  </Grid>
                </div>)
            })}
          </Paper>
          {fileloading && <CircularProgress size={48} className={classes.downloadProgress} />}
        </div>}
    </React.Fragment >
  )
}

export default QAEditArea


